
export const ITEMS_PER_PAGE = 10;

export const URGENCY = [
    "Urgent",
    "Non-Urgent",
    "Scheduled"
]

export const CATEGORY = [
    { 
        key:  "Reactive",
        description: "Reactive Maintenance",
        subcategory: [
            "Controller Fault",
            "Detector Fault",
            "PBU Fault",
            "Electrical Fault",
            "Lamp Fault",
            "Comms Fault",
            "Sign Fault",
            "Knockdown",
            "Twisted Head",
            "Graffiti",
            "Check Operation and Detection",
            "Lights Out",
            "Other"
        ],
        sla_attend: [
            "2",
            "4",
            "18",
        ],
        sla_attend_sdcc_urgent: [
            "2",
            "18",
        ],
        sla_attend_sdcc_non_urgent: [
            "4",
            "18",
        ],
        sla_attend_in: "hrs",
        sla_repair: [
            "5",
            "7",
            "24",           
        ],
        sla_repair_sdcc_urgent: [
            "5",
            "24",
        ],
        sla_repair_sdcc_non_urgent: [
            "10",
            "24",
        ],
        sla_repair_in: "hrs",
    },
    {   key:  "PPM",
        description: "Planned Preventative Maintenance (PPM)",
        subcategory: [
            "Periodic Inspection",
            "Periodic Inspection Report",
            "Annual Inspection (Signals)",
            "Annual Inspection (Structures)",
            "Annual Inspection (Signs)",
            "Annual Inspection Report",
            "Routine Maintenance",
            "Non LED Lamp replacement"
        ],
        sla_attend: [
            "7",
            "14",
        ],
        sla_attend_in: "days",
        sla_repair: [
            "7",
            "14",           
        ],
        sla_repair_in: "days",
    },
    {   key:  "Switch off / on",
        description: "Switch off / on",
        subcategory: [
            "Utility Contractor",
            "Resurfacing contractor",
            "N/A ",
        ]   
    },
    {   key:  "Upgrade",
        description: "Upgrade",
        subcategory: [
            "Refurbishment",
            "New installation",
            "N/A ",
        ]   
    },
    {   key:  "Signs",
        description: "Signs",
        subcategory: [
            "Sign fault",
            "Works Order",
            "N/A ",
        ]   
    },
    {   key:  "Projects",
        description: "Projects",
        subcategory: [
            "Design Review",
            "Contract Document Review",
            "Preliminary Design",
            "Detailed Design",
            "Material Approval",
            "Site Inspection",
            "Technical Report",
            "Techical Advice",
            "Snagging",
            "Correspondance",
            "Other"
        ]       
    },
    {   key:  "Technical Support",
        description: "Technical Support",
        subcategory: [
            "Design Review",
            "Contract Document Review",
            "Preliminary Design",
            "Detailed Design",
            "Material Approval",
            "Site Inspection",
            "Pre Connection Snag",
            "Post Connection Snag",
            "Technical advice",
            "SCATs",
            "Comms",
            "Other"
        ]       
    },
    {   key:  "Public Lighting",
        description: "Public Lighting",
        subcategory: [
            "Lighting Design",
            "Design Review",
            "Material Approval",
            "Site Inspection",
            "Other"
        ]       
    },
    {   key:  "Inspection Request",
        description: "Inspection Request",
        subcategory: [
        "Inspection",
        ]       
    },
    {   key:  "Other",
        description: "Other",
        subcategory: [
        "N/A ",
        ]       
    },
]


export const TYPE_FAULT = [
    "PBU Fault",
    "Controller Fault",
    "Electrical Fault",
    "Lamp Fault",
    "Comms Fault",
    "Vandalism",
    "ESB power Cut",
    "Vehicle strike",
    "Twisted signal head",
    "Detector fault",
    "Lights Out",
    "Other",
    "N/A",
];

export const ASSET_TYPE = [
    "Fibre Optic",
    "Pedestrian Crossing",
    "Pelican Crossing",
    "School Warning Sign",
    "Signalised Junction",
    "Toucan Crossing",
    "Zebra Crossing",
    "Sign - Other",
    "CCTV",  
    "Design & Construction",
    "Periodic Speed Limit Sign",
    "Public Lighting",
    "Other",
]
